enum DiscountCodeTypes {
  AMOUNT = 'Amount',
  PERCENTAGE = 'Percentage',
}
export { DiscountCodeTypes }
